import { LookupResponse } from '@tamwely-types/common';
import { OfferResponse } from './customer-dashboard';

export enum LoanTypeId {
  PERSONAL_LOAN = 1,
  REAL_ESTATE_LOAN = 2,
  FINANCE_PAYOUT = 3,
  CAR_LOAN = 4,
}

export interface CreateLoanRequest {
  loanTypeId: number;
  requestedAmount: number;
  salary: number;
  monthlyIncome: number;
  monthlyExpenses: number;
  isReadyToTransferSalary: boolean;
  isHaveAnotherLoan: boolean;
  employerSectorId: number;
  companyName: string;
  financeTenor: number;
  comment: string;
}

export interface AdvisorLoanRequestResponse {
  id: number;
  loanType: LookupResponse;
  dateOfBirth: string;
  requestedAmount: number;
  salary: number;
  monthlyIncome: number;
  monthlyExpenses: number;
  readyToTransferSalary: boolean;
  haveAnotherLoan: boolean;
  employerSector: LookupResponse;
  companyName: string;
  financeTenor: number;
  comment: string;
  proposedOffer: OfferResponse | null;
}

export interface LoanRequestFilter {
  id?: number;
  companyName?: string;
  salaryMin?: number;
  salaryMax?: number;
  dateOfBirthFrom?: string;
  dateOfBirthTo?: string;
}

export interface AdvisorRequestsParams extends LoanRequestFilter {
  page: number;
  size: number;
}

export const DEFAULT_ADVISOR_PARAMS: AdvisorRequestsParams = {
  page: 0,
  size: 10,
};
